export const committee = [
  {
    id: 'arthur-pendelton',
    name: 'Arthur Pendelton',
    role: 'President',
    image:
      'https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    bio: "Arthur has been a member since 1995 and has served on the committee for over a decade. He brings extensive experience in corporate governance and a deep passion for the association's legacy.",
  },
  {
    id: 'eleanor-vance',
    name: 'Eleanor Vance',
    role: 'Vice President',
    image:
      'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    bio: 'Eleanor leads the strategic planning initiatives for the club. Her background in luxury hospitality has been instrumental in elevating our dining and accommodation standards.',
  },
  {
    id: 'james-sterling',
    name: 'James Sterling',
    role: 'Treasurer',
    image:
      'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    bio: "With a 30-year career in investment banking, James ensures the financial stability and prudent management of the club's resources and capital projects.",
  },
  {
    id: 'victoria-chen',
    name: 'Victoria Chen',
    role: 'Secretary',
    image:
      'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    bio: 'Victoria oversees membership relations and club communications. She is dedicated to fostering a welcoming and inclusive community for all members.',
  },
]
